<template>
  <div>
    <v-container grid-list-xl class="content-header">
      <v-flex xs12 sm10 offset-sm1>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-layout row v-bind="binding" justify-space-between>
            <v-flex xs12 sm6>
              <v-text-field
                label="Name"
                color="primary"
                :rules="nameRules"
                v-model="formData.name">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                label="Email"
                color="primary"
                :rules="emailRules"
                v-model="formData.email"
                type="email"
                @blur="checkEmail"
                required>
              </v-text-field>
            </v-flex>                    
          </v-layout>
          <v-layout row v-bind="binding" justify-space-between>
            <v-flex xs12 sm8>
              <v-checkbox 
                v-model="formData.isSubscribed"
                class="chb-padding" 
                :value="1" 
                label="Email Subscription list"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm4>
              <v-card-actions>
                <v-btn
                  color="primary"
                  @click="submit"
                  :disabled="!valid">
                  submit
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-form>
        <v-alert color="success" class="success mt-3" icon="check" value="true" v-if="success">{{success}}</v-alert>
        <v-alert color="error" class="err mt-3" icon="warning" value="true" v-if="err">{{err}}</v-alert>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
  import webHelper from '../../helpers/web';

  export default {
    data: () => ({
      valid: true,
      formData: {
        name: '',
        email: '',
        isSubscribed: false,
      },
      user: {},
      nameRules: [
        v => (v.length <= 35) || 'Name must be less than 35 characters',
      ],
      emailRules: [
        v => !!v || 'Email is required',
        // eslint-disable-next-line
        v => (v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase())) || 'Email is not valid',
      ],
      success: '',
      err: '',
    }),
    computed: {
      binding() {
        const binding = {};
        if (this.$vuetify.breakpoint.xsOnly) binding.column = true;
        return binding;
      },
    },
    methods: {
      async checkEmail() {
        this.err = '';
        const where = {};
        where.email = this.formData.email;
        if (this.user) {
          where.id = this.user._id;
        }
        const res = await webHelper.get(this, 'user/email', where);
        if (res.failed || !res.isAvailable) {
          this.err = 'Email You chose is already taken.';
        }
      },
      async submit() {
        this.err = '';
        const update = {};
        ['name', 'email', 'isSubscribed'].forEach((key) => {
          if (this.formData[key] !== this.user[key]) {
            update[key] = this.formData[key];
            if (key === 'isSubscribed') {
              update[key] = this.formData[key] !== null ? 1 : 0;
            }
          }
        });
        if (Object.keys(update).length > 0) {
          update.id = this.user._id;
          const res = await webHelper.put(this, 'user/profile', update);
          if (res.failed) {
            this.err = 'Failed to edit profile';
            return;
          }

          ['name', 'email', 'isSubscribed'].forEach((key) => {
            this.user[key] = update[key];
          });
        }
        this.success = 'Update successful';
        setTimeout(() => {
          this.success = '';
        }, 3000);
      },
    },
    async created() {
      const res = await webHelper.get(this, 'user/profile');
      if (res.failed) {
        this.err = 'Failed to get user';
      }
      const { user } = res;
      this.user = user;
      this.formData.name = user.name;
      this.formData.email = user.email;
      this.formData.isSubscribed = user.isSubscribed;
    },
  };
</script>

<style scoped lang="scss">
  .logo-img {
    width: auto;
    margin: 3px auto 0;
    overflow: hidden;
    height: 35px;
    position: relative;
    img {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      width: auto;
      max-width: 100%;
      height: 100%;
    }
  }
  h3 {
    text-transform: uppercase;
  }
  main {
    padding-top: 64px;
  }
  .card {
    padding: 24px !important;
  }
  .card__actions {
    position: relative;
    .btn {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      margin: 0;
    }
  }
  .chb-padding {
    padding-top: 4px !important;
  }
  @media only screen and (max-width: 600px) {
    .card__actions {
      .btn {
        position: relative;
        left: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userManager/Profile.vue